import {actionTypes} from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import {getMessage} from '../../utilities/getMessage';

export const updateFourD = (id, status, token) => async dispatch => {
    dispatch({
        type: actionTypes.UPDATE_4D_START
    })
    const options = {
        url: `${api}/fourDNumbers/${id}`,
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        data: {status}
    }
    await axios(options)
        .then(response => dispatch({
            type: actionTypes.UPDATE_4D_SUCCESS,
            payload: response.data
        }))
        .catch(error => dispatch({
            type: actionTypes.UPDATE_4D_FAIL,
            payload: getMessage(error)
        }))
}